import React from 'react';

import { ExpenditureContributionValueType, ExpenditureType } from '../../types';
import ExpenditureTable from '../components/ExpenditureTable';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import SumTableRow from '../components/SumTableRow';

export default function Opex() {
  const { t } = useTranslation('esg', {
    keyPrefix: 'taxonomy.contributions',
  });
  return (
    <>
      <Typography>{t('text')}</Typography>
      <br />
      <ExpenditureTable
        type={ExpenditureType.Opex}
        valueType={ExpenditureContributionValueType.A}
      />
      <ExpenditureTable
        type={ExpenditureType.Opex}
        valueType={ExpenditureContributionValueType.B}
      />
      <ExpenditureTable
        type={ExpenditureType.Opex}
        valueType={ExpenditureContributionValueType.C}
      />

      <SumTableRow type={ExpenditureType.Opex} />
    </>
  );
}
